import React, { Component } from 'react';
import './App.css';

class Done extends Component {
    render() {
        return (
            <div>
            </div>
        );
    }
}

export default Done;
